module.exports = __webpack_public_path__ + "img/enerman-etisol_new_dark.970ba170.svg";